export interface RawMaterialLineData {
	confirmedCost: boolean;
	grossMaterialCost: number;
	isCoil: boolean;
	marginPercentage: number;
	materialGauge: number;
	materialGrossWeight: number;
	materialLength: number;
	materialTonnage: number;
	materialWidth: number;
	netMaterialCost: number;
	netWeight?: number;
	overhead: number; // kept for backward compat, calculated from marginPercentage
	partGrossWeight: number;
	partPitch: number;
	partWidth: number;
	partsPerBlow: number;
	partsPerMaterial: number;
	pricePerPart?: number; // Fast quoting only
	purchasableItemId: number;
	rawMaterialPricePerKg: number; // kept for backward compat (value now represents per-tonne)
	scrapCostPerKg: number;
	scrapValue: number;
	scrapWeight: number;
	supplierId?: number;
	totalMaterialCost?: number; // Fast quoting only - total for the quoted batch
}

export class RawMaterialLineData implements RawMaterialLineData {
	confirmedCost = false;
	grossMaterialCost = 0;
	isCoil = false;
	marginPercentage = 0;
	materialGauge = 0;
	materialGrossWeight = 0;
	materialLength = 0;
	materialTonnage = 0;
	materialWidth = 0;
	netMaterialCost = 0;
	overhead = 0;
	partGrossWeight = 0;
	partPitch = 0;
	partWidth = 0;
	partsPerBlow = 0;
	partsPerMaterial = 0;
	purchasableItemId = 0;
	rawMaterialPricePerKg = 0;
	scrapCostPerKg = 0;
	scrapValue = 0;
	scrapWeight = 0;
	constructor(data?: Partial<RawMaterialLineData>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}